export { default as component } from "../../../../src/routes/[prefix]/(feature)/activity-realization/+page.svelte";